var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m226.36 160.92c-9.67 0-17.51 7.84-17.51 17.51v95.28c0 27.17 22.1 49.27 49.27 49.27h63.52c9.67 0 17.51-7.84 17.51-17.51s-7.84-17.51-17.51-17.51h-63.52c-7.86 0-14.25-6.39-14.25-14.25v-95.28c0-9.68-7.84-17.51-17.51-17.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.99 87.12c-47.01-47-109.51-72.89-175.99-72.89-36.28 0-71.78 7.84-104.29 22.85l5.16-13.19c3.52-9.01-.93-19.16-9.93-22.68-9.01-3.52-19.16.93-22.68 9.93l-21.59 55.23c-2.41 6.16-2.15 13.11.71 19.08 2.86 5.96 8.12 10.52 14.43 12.5l56.58 17.74c1.74.55 3.51.81 5.24.81 7.45 0 14.35-4.79 16.7-12.27 2.89-9.23-2.24-19.05-11.47-21.94l-27.93-8.76c30.43-15.93 64.32-24.27 99.06-24.27 57.13 0 110.83 22.25 151.23 62.64 40.39 40.4 62.64 94.1 62.64 151.23s-22.25 110.84-62.64 151.23c-40.4 40.39-94.1 62.64-151.23 62.64s-110.84-22.25-151.23-62.64c-40.4-40.4-62.64-94.1-62.64-151.23 0-33.98 7.73-66.46 22.97-96.54 4.37-8.62.92-19.16-7.7-23.53s-19.16-.92-23.53 7.7c-17.75 35.02-26.75 72.82-26.75 112.35 0 66.48 25.89 128.98 72.9 175.99s109.51 72.9 175.99 72.9 128.98-25.89 175.99-72.9 72.9-109.51 72.9-175.99-25.89-128.98-72.9-175.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.d88dd97d7a36e2a1f14d2616c12df326.svg";
export { ForwardRef as ReactComponent };